import { render, staticRenderFns } from "./PaginationInput.vue?vue&type=template&id=5fb23bfa&scoped=true&"
import script from "./PaginationInput.vue?vue&type=script&lang=js&"
export * from "./PaginationInput.vue?vue&type=script&lang=js&"
import style0 from "./PaginationInput.vue?vue&type=style&index=0&id=5fb23bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb23bfa",
  null
  
)

export default component.exports